/* eslint-disable camelcase */
import React, { Component } from 'react';
import { Modal, Button, Input, Radio } from '@tinper/next-ui';
import _ from 'lodash';
import '../style/filterModal.less';
import DataLoader from '../../../utils/query_scheme/data_loader';
import LeftFilterModal from './LeftFilterModal'
import RightFilterModal from './RightFilterModal'
import { v4 as uuid } from 'uuid'

export default class FilterModal extends Component {
  constructor (props) {
    super(props);
    this.state = {
      ValueList: [], // 选中的条件列表
      isDefault: false, // 是否为默认方案
      isPublic: true, // 是否公共方案
      autoSearch: false, // 自动搜索
      solutionName: '', // 方案名称
      solutionId: '', // 方案id
      showConfirm: false, // 保存确认弹窗
      mention: false, // 提示信息
      User: props.User
    };
    this.initField = []; // 初始字段
    this.dataLoader = props.dataLoader
    if (!this.dataLoader) {
      this.dataLoader = new DataLoader(this.props)
    }
  }

  async componentDidMount () {
    if (!this.props.User) {
      this.getauthority()
    }
    this.props.JSONSchema?.initParams?.(this.dataLoader.getParams)
    if (!this.props.solutionMetaInfo) {
      const filterSchemeJSONSchema = this.props.JSONSchema?.getJSONSchema?.('queryscheme', false)
      if (!filterSchemeJSONSchema?.schemeList) {
        await filterSchemeJSONSchema.getSolutionDataList?.()
      }
      const solutionMetaInfo = this.props.JSONSchema?.getSolutionMetaBySchemeId?.({solutionId: filterSchemeJSONSchema?.currentScheme?.solutionId || 'systemScheme'})
      if (solutionMetaInfo) {
        this.props.solutionMetaInfo = solutionMetaInfo
        this.initState(solutionMetaInfo)
      }
    }
    // this.props.JSONSchema?.initSchemeModal(this.props.conditionsList)
  }

  initState (solutionMetaInfo) {
    if (!solutionMetaInfo) return
    this.initField = {
      ValueList: _.cloneDeep(solutionMetaInfo.fields),
      solutionName: solutionMetaInfo.caption,
      solutionId: solutionMetaInfo.solutionId,
      isDefault: solutionMetaInfo.isDefault,
      isPublic: solutionMetaInfo.isPublic ?? true,
      autoSearch: solutionMetaInfo.autoSearch
    };
    this.setState({
      ValueList: _.cloneDeep(solutionMetaInfo.fields),
      solutionName: solutionMetaInfo.caption,
      solutionId: solutionMetaInfo.solutionId,
      isDefault: solutionMetaInfo.isDefault,
      isPublic: solutionMetaInfo.isPublic ?? true,
      autoSearch: solutionMetaInfo.autoSearch,
      currentId: solutionMetaInfo.solutionId
    });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps (nextProps) {
    const solutionMetaInfo = nextProps.solutionMetaInfo;
    // 初始化
    if (solutionMetaInfo !== this.props.solutionMetaInfo) {
      this.initState(solutionMetaInfo)
    }
  }

  // 获取用户权限
  async getauthority () {
    try {
      const { code, data } = await this.dataLoader.checkAuthByCode();
      if (code === 200) {
        this.setState({ User: data });
      }
    } catch (error) {
    }
  }

  // 设置方案元数据(valueList)
  setValueList = (data) => {
    this.setState({ ValueList: data });
  }

  // 设置为默认
  setDefault = () => {
    const { isDefault } = this.state;
    if (this.props.solutionMetaInfo.isPublic && this.props.solutionMetaInfo.isDefault) {
      this.props.JSONSchema?.utils.message.danger(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800DA', '公共默认方案不可取消默认状态'));
    } else {
      this.setState({ isDefault: !isDefault });
    }
  }

  // 设置是否自动搜索
  setAutoLoad = () => {
    const { autoSearch } = this.state;
    this.setState({ autoSearch: !autoSearch })
  }

  // 取消保存确认弹窗
  handleConfirmCancel () {
    this.setState({ showConfirm: false });
  }

  // 模态框按钮
  footerButtons () {
    const { isEdit } = this.props
    const User = this.state.User || this.props.User
    const userdef_schemaSetting = User && User.userdef_schemaSetting
    return (isEdit
      ? <div className='query-button'>
        <Button type='secondary' fieldid={`${this.props.fieldid}|cancel`} className='cancelScheme' onClick={this.closeAddModal}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D5', '取消', undefined, { returnDom: true, placement: 'top' })}</Button>
        {this.props.bAdvance && <Button type='primary' fieldid={`${this.props.fieldid}|search`} className='search' onClick={this.searchByFilter}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A5FA38605100003', '查询', undefined, { returnDom: true, placement: 'top' })}</Button>}
        {this.props.JSONSchema?.hasQueryScheme && !this.props.bAdvance && <Button type='dark' className='confirmScheme' fieldid={`${this.props.fieldid}|saveOther`} onClick={() => this.openIsNullOrNotConfirm('other')}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D6', '另存为新方案', undefined, { returnDom: true, placement: 'top' })}</Button>}
        {(userdef_schemaSetting || !this.state.isPublic) && this.props.JSONSchema?.hasQueryScheme && !this.props.bAdvance && <Button type='primary' fieldid={`${this.props.fieldid}|save`} disabled={this.state.solutionId === 'systemScheme'} className='confirmScheme' onClick={() => this.openIsNullOrNotConfirm('curr')}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D7', '保存方案', undefined, { returnDom: true, placement: 'top' })}</Button>}
        {/* <Button type='primary' className='confirmScheme' onClick={() => this.searchByCondition()}>查询</Button> */}
      </div>
      : <div className='query-button'>
        <Button type='secondary' className='cancelScheme' fieldid={`${this.props.fieldid}|cancel`} onClick={this.closeAddModal}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D5', '取消', undefined, { returnDom: true, placement: 'top' })}</Button>
        <Button type='primary' className='confirmScheme' fieldid={`${this.props.fieldid}|save`} onClick={() => this.openIsNullOrNotConfirm('other')}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D8', '保存', undefined, { returnDom: true, placement: 'top' })}</Button>
      </div>
    )
  }

  searchByFilter = () => {
    const { ValueList } = this.state;
    const conditionsList = []
    ValueList.forEach(item => {
      const querySearchValue = this.props.JSONSchema?.getQueryValue?.(item)
      if (item.mulFieldLike && item.mulFieldLike.length && querySearchValue?.items?.length > 0) {
        conditionsList.push(querySearchValue)
      } else if (!this.props.JSONSchema?.isEmptyValue(querySearchValue.v1) || !this.props.JSONSchema?.isEmptyValue(querySearchValue.v2)) {
        conditionsList.push(querySearchValue)
      }
    })
    this.props.JSONSchema?.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A8EACCC05580004', '高级查询') || '高级查询')
    this.props.JSONSchema?.setAdvanceCondition(conditionsList)
    this.props.JSONSchema?.searchByFilter()
    this.closeAddModal()
  }

  openIsNullOrNotConfirm = (type) => {
    const _this = this
    if ((this.state.ValueList.filter(item => item.compareLogic === 'is_null' || item.compareLogic === 'is_not_null')).length > 0) {
      this.props.JSONSchema?.utils.confirm({
        title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B6CD62604D00014', '当前查询方案存在“非空”（或“为空”）查询，是否继续保存？', undefined, { returnDom: true, placement: 'top' }), onOk: () => {
          _this.openConfirm(type)
        }
      })
    } else if (this.state.ValueList.length === 0) {
      this.props.JSONSchema?.utils.confirm({
        title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B6CD62604D00013', '当前查询方案为空，保存后查询条件将丢失，是否继续保存？', undefined, { returnDom: true, placement: 'top' }), onOk: () => {
          _this.setState({ autoSearch: true })
          _this.openConfirm(type)
        }
      })
    } else {
      this.openConfirm(type)
    }
  }

  // 打开保存确认弹窗
  openConfirm (type) {
    if (type === 'curr') { // 当前方案
      this.isSaveCurrent = true
    } else if (type === 'other') { // 新方案
      this.isSaveCurrent = false
      this.setState({ solutionName: '', solutionId: '' });
    }
    this.setState({ showConfirm: true });
  }

  // 保存
  onSaveSolution = () => {
    const { solutionName, isPublic, isDefault, autoSearch, ValueList, solutionId } = this.state;
    // 如果是新方案, 重新赋值alias
    if (this.isSaveCurrent === false) {
      ValueList.map(item => {
        item.alias = item.controlType + uuid().slice(0, 6)
        item.visible = true;
      })
    }

    // 计算方案名称长度
    let num = 0;
    for (let i = 0; i < solutionName.length; i++) {
      const charlen = solutionName.charCodeAt(i);
      if ((charlen >= 0x0001 && charlen <= 0x007e) || (charlen >= 0xff60 && charlen <= 0xff9f)) {
        num++;
      } else {
        num += 2;
      }
    }

    // 校验
    if (!solutionName) {
      this.props.JSONSchema?.utils.message.danger(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800CE', '名称不可为空'));
      this.setState({ mention: true });
      return;
    } else if (solutionName === lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800CF', '系统方案', undefined, { returnDom: true, placement: 'top' })) {
      this.props.JSONSchema?.utils.message.danger(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D0', '名称不可为"系统方案"'));
      this.setState({ mention: true });
      return;
    } else if (num > 20) {
      this.props.JSONSchema?.utils.message.danger(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D2', '输入长度超出限制：中文最多10个汉字，英文最多20个字母'));
      this.setState({ mention: true })
      return;
    } else {
      this.setState({ mention: false, showConfirm: false })
    }

    const submitData = {
      billNo: this.props.JSONSchema?.billNo,
      tplId: this.props.JSONSchema?.tplId,
      data: {
        caption: solutionName,
        isPublic,
        isDefault,
        autoSearch,
        fields: ValueList?.filter(item => item?.visible === true),
        dataSource: this.props.dataSource,
        solutionId: solutionId || undefined // 编辑时传
      }
    };
    this.saveSolutionRequest(submitData)
  }

  // 保存接口
  saveSolutionRequest = async (submitData) => {
    const { code, message } = await this.dataLoader.saveSolution(submitData)
    if (code === 200) {
      this.props.JSONSchema?.utils.message.success(message);
      this.props.closeAddModal();
      this.props.getSolutionDataList();
      submitData.data.solutionId == undefined ? this.props.JSONSchema?.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D6', '另存为新方案') || '另存为新方案') : this.props.JSONSchema?.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D7', '保存方案') || '保存方案')
      if (this.state.solutionId === this.props.currentId) { // 如果编辑的方案是当前方案, 则保存成功后刷新查询区
        // this.props.initDefaltSchema?.(submitData.data);
        this.props.chooseScheme(submitData.data)
      }
    } else {
      this.props.JSONSchema?.utils.message.danger(message);
    }
  }

  // 打开自定义过滤条件弹窗
  openDefined = () => { }

  // 保存方案弹窗
  getConfirmModal () {
    const { isPublic, showConfirm, solutionName } = this.state;
    const User = this.state.User || this.props.User
    let isEdit = this.props.isEdit;
    // 另存为
    if (this.isSaveCurrent === false) { // 新方案
      isEdit = false
    }
    const userdef_schemaSetting = User?.userdef_schemaSetting;
    const showPlan = userdef_schemaSetting;
    if (!isEdit && !userdef_schemaSetting && isPublic) {
      // 新增 无权限
      this.setState({ isPublic: false });
    }
    let input_schemename = '';
    if (this.state.mention) {
      input_schemename = 'input_schemename'
    }
    // const schemeMobileList = [];
    // const schemeMobileListEle = schemeMobileList && schemeMobileList.length ? <Radio.Group onChange={(e) => { this.setState({ isPublic: e }) }} value={isPublic}>
    //   <Radio value={0}>Web个人方案</Radio>
    //   <Radio value={3}>移动个人方案</Radio>
    // </Radio.Group> : null
    const radioGroup = <div className={showPlan ? 'show_pubper' : 'hide_pubper'}>
      {userdef_schemaSetting
        ? <Radio.Group onChange={(e) => { this.setState({ isPublic: e }) }} value={isPublic}>
          <Radio fieldid={`${this.props.fieldid}|webPublic`} value={true}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D3', 'Web公共方案', undefined, { returnDom: true, placement: 'top' })}</Radio>
          <Radio fieldid={`${this.props.fieldid}|webPersonal`} value={false}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D4', 'Web个人方案', undefined, { returnDom: true, placement: 'top' })}</Radio>
          {/* {schemeMobileList && schemeMobileList.length && <Radio value={2}>移动公共方案</Radio>}
          {schemeMobileList && schemeMobileList.length && <Radio value={3}>移动个人方案</Radio>} */}
        </Radio.Group>
        :
        // schemeMobileListEle
        null
      }
    </div>
    return (
      <Modal
        title={isEdit ? this.isSaveCurrent ? lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D7', '保存方案', undefined, { returnDom: true, placement: 'top' }) : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D6', '另存为新方案', undefined, { returnDom: true, placement: 'top' }) : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D9', '新增方案', undefined, { returnDom: true, placement: 'top' })}
        visible={showConfirm}
        maskClosable={false}
        draggable={true}
        width={400}
        onCancel={() => this.handleConfirmCancel()}
        className='filter-modal-confirm'
      >
        <Input
          onBlur={value => { if (value) this.setState({ mention: false }) }}
          className={input_schemename + this.state.mention ? ' has-error' : ''}
          type='text'
          value={solutionName}
          fieldid={`${this.props.fieldid}|schemeNameInput`}
          onChange={(e) => { this.setState({ solutionName: e }) }}
          placeholder={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D1', '名称长度不可超过20个字符', undefined, { returnDom: true, placement: 'top' })}
        />
        {!isEdit && radioGroup}
        <Modal.Footer>
          <Button type='secondary' onClick={(e) => this.handleConfirmCancel(e)} fieldid={`${this.props.fieldid}|confirm|cancel`}>{lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B80029', '取消', undefined, { returnDom: true, placement: 'top' })}</Button>
          <Button type='primary' onClick={this.onSaveSolution} fieldid={`${this.props.fieldid}|confirm|ok`}>{lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B80034', '确定', undefined, { returnDom: true, placement: 'top' })}</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  closeAddModal = () => {
    // 字段变化但没有保存时还原为初始字段
    this.setState(this.initField);
    this.props.closeAddModal()
  }

  editSchemeInfo = (val) => {
    this.initState(val)
  }

  AddScheme = () => {
    this.props.isEdit = false
    this.initState({ fields: [] })
  }

  render () {
    const { showModal, isEdit, schemeList, conditionsList, currentId } = this.props;
    const User = this.state.User || this.props.User
    const footer = this.footerButtons();
    return (
      <div className='ynf-scheme-list'>
        <Modal
          className='schemeContent'
          title={isEdit ? lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800DB', '编辑方案', undefined, { returnDom: true, placement: 'top' }) : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800D9', '新增方案', undefined, { returnDom: true, placement: 'top' })}
          visible={showModal}
          onCancel={this.closeAddModal}
          maskClosable={false}
          draggable={true}
          height={500}
          width={800}
          footer={footer}
        >
          <div className='Scheme-Content-body-left'>
            <LeftFilterModal
              hasQueryScheme={this.props.JSONSchema?.hasQueryScheme}
              isEdit={isEdit}
              conditionsList={conditionsList}
              User={User}
              fieldid={this.props.fieldid}
              ValueList={this.state.ValueList}
              setSolutionMetaList={this.setValueList}
              openDefined={this.openDefined}
              schemeList={schemeList}
              AddScheme={this.props.AddScheme || this.AddScheme}
              editSchemeInfo={this.props.editSchemeInfo || this.editSchemeInfo}
              currentId={this.state.currentId || currentId}
              deleteScheme={this.props.deleteScheme}
              setDefaultScheme={this.props.setDefaultScheme}
            />
          </div>
          <div className='YNF-Scheme-Content-body'>
            <RightFilterModal
              showModal={showModal}
              bEdit='false'
              bAdvance={this.props.bAdvance}
              render={this.props.render}
              ValueList={this.state.ValueList}
              setValueList={this.setValueList}
              isDefault={this.state.isDefault}
              fieldid={this.props.fieldid}
              setDefault={this.setDefault}
              autoSearch={this.state.autoSearch}
              setAutoLoad={this.setAutoLoad}
              parentAlias={this.props.parentAlias}
              authId={this.props.authId}
              JSONSchema={this.props.JSONSchema}
            />
          </div>
          <Modal.Footer>{footer}</Modal.Footer>
          {this.getConfirmModal()}
        </Modal>
      </div>
    );
  }
}
